import { cn } from "@/lib/utils";

export function RaqozMark({ className = "" }: { className?: string }) {
  return (
    <svg aria-hidden="true" className={cn("shrink-0", className)} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="14" fill="currentColor" />
      <circle cx="23" cy="23" r="10.5" stroke="white" strokeWidth="3.5" />
      <path d="M30.5 30.5L38 38" stroke="#D9AA62" strokeWidth="4" strokeLinecap="round" />
      <path d="M12.5 23H33.5" stroke="#77DDD0" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="12.5" cy="23" r="2.5" fill="#D9AA62" />
      <circle cx="23" cy="23" r="2.5" fill="white" />
      <circle cx="33.5" cy="23" r="2.5" fill="#77DDD0" />
      <circle cx="38" cy="38" r="2.5" fill="#D9AA62" />
    </svg>
  );
}

export function RaqozLogo({ className = "", inverse = false, owner = false }: { className?: string; inverse?: boolean; owner?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-3", inverse ? "text-white" : "text-[#0d2635]", className)}>
      <RaqozMark className={cn("size-10 drop-shadow-sm", inverse ? "text-[#159486]" : "text-[#0f766e]")} />
      <span className="leading-none">
        <strong className="block text-[1.05rem] font-black tracking-[.22em]">RAQOZ</strong>
        {owner && <span className={cn("mt-1.5 block text-[9px] font-semibold tracking-[.11em]", inverse ? "text-white/55" : "text-slate-500")}>BY CYCLOTRON TECHNOLOGIES</span>}
      </span>
    </span>
  );
}
